"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Container = _interopRequireDefault(require("./components/Container"));

var _amsVerifyEmail = _interopRequireDefault(require("../wrappers/ams-verify-email"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _default = (0, _amsVerifyEmail["default"])(function (_ref) {
  var verified = _ref.verified,
      props = _objectWithoutProperties(_ref, ["verified"]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex-1 flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, verified === "waiting" ? "Verifying Email..." : verified === "failed" ? "Email verification failed." : "Email verification succeeded."));
});

exports["default"] = _default;